<div *ngIf="show" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4">
    <h3 class="text-lg font-semibold mb-4">{{ title }}</h3>
    <p class="text-gray-600 mb-6">{{ message }}</p>
    <div class="flex space-x-3 justify-end">
      <button (click)="onCancel()" class="px-4 py-2 text-gray-600 border border-gray-300 rounded hover:bg-gray-50">
        {{ cancelText }}
      </button>
      <button (click)="onConfirm()" class="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600">
        {{ confirmText }}
      </button>
    </div>
  </div>
</div>